import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "wrapper",
  class: "icone-widget-wrapper"
}
const _hoisted_2 = { class: "icone-widget-title mb-2" }
const _hoisted_3 = { class: "title is-size-4 m-0" }
const _hoisted_4 = { class: "barlow" }
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, " - ", -1 /* HOISTED */)
const _hoisted_7 = ["title"]
const _hoisted_8 = {
  key: 0,
  class: "icone-widget-content"
}
const _hoisted_9 = { class: "w-100 mb-5" }
const _hoisted_10 = { class: "has-text-grey" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_12 = { class: "icone-wrapper" }
const _hoisted_13 = { class: "icone-bar" }
const _hoisted_14 = {
  ref: "segment ",
  class: "icone-bar-segment segment-0"
}
const _hoisted_15 = {
  ref: "segment ",
  class: "icone-bar-segment segment-1"
}
const _hoisted_16 = {
  ref: "segment ",
  class: "icone-bar-segment segment-2"
}
const _hoisted_17 = {
  ref: "segment ",
  class: "icone-bar-segment segment-3"
}
const _hoisted_18 = {
  ref: "segment ",
  class: "icone-bar-segment segment-4"
}
const _hoisted_19 = {
  ref: "segment ",
  class: "icone-bar-segment segment-5"
}
const _hoisted_20 = {
  key: 1,
  class: "icone-widget-content"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = ["data-tooltip"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_WidgetBase = _resolveComponent("WidgetBase")!

  return (_openBlock(), _createBlock(_component_WidgetBase, {
    widget: _ctx.widget,
    mode: _ctx.widgetMode
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('dashboard.icone_widget.title')), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("span", {
              title: _ctx.icone?.start
            }, _toDisplayString(_ctx.week.start?.format('ll')), 9 /* TEXT, PROPS */, _hoisted_5),
            _hoisted_6,
            _createElementVNode("span", {
              title: _ctx.icone?.end
            }, _toDisplayString(_ctx.week.end?.format('ll')), 9 /* TEXT, PROPS */, _hoisted_7)
          ])
        ]),
        (_ctx.isValid || _ctx.editable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.$t('dashboard.icone_widget.description_1')) + " ", 1 /* TEXT */),
                  _hoisted_11,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.icone_widget.description_2')), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_ctx.positionClass !== '')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass([_ctx.positionClass, "cursor mdi mdi-chevron-down has-text-link pos-{{icone}}"])
                    }, null, 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                    trigger: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, "0", 512 /* NEED_PATCH */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.iconeLabel[0]), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                    trigger: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, "1", 512 /* NEED_PATCH */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.iconeLabel[1]), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                    trigger: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, "2", 512 /* NEED_PATCH */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.iconeLabel[2]), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                    trigger: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, "3", 512 /* NEED_PATCH */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.iconeLabel[3]), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                    trigger: _withCtx(() => [
                      _createElementVNode("div", _hoisted_18, "4", 512 /* NEED_PATCH */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.iconeLabel[4]), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                    trigger: _withCtx(() => [
                      _createElementVNode("div", _hoisted_19, "5", 512 /* NEED_PATCH */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.iconeLabel[5]), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("img", {
                width: "50",
                src: require('@/no-data-icon.svg').default
              }, null, 8 /* PROPS */, _hoisted_21),
              _createElementVNode("span", {
                "data-tooltip": JSON.stringify(_ctx.mean),
                class: "w-100 has-text-grey is-size-5 has-text-centered has-first-letter-uppercase"
              }, _toDisplayString(_ctx.$t('dashboard.icone_widget.not_enough_data')), 9 /* TEXT, PROPS */, _hoisted_22)
            ]))
      ], 512 /* NEED_PATCH */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["widget", "mode"]))
}